const deleteFromLocalStorage = (key) => {
  return localStorage.removeItem(key)
}

export default deleteFromLocalStorage
